import React from 'react';
import { Root, createRoot } from 'react-dom/client';
import App from './App';
import { IConfig } from './config/interfaces';
import { Context } from './context/context';
import * as Sentry from '@sentry/react';
import './stylesheets/index.css';

let root: Root | null = null;

window.addEventListener('DOMContentLoaded', (event) => {
	window.parent.postMessage(JSON.stringify({ action: 'init' }), '*');
	// window.removeEventListener('DOMContentLoaded', () => null);
});
// Extract the hostname from REACT_APP_BASE_URL
const baseUrl = process.env.REACT_APP_BASE_URL;
const apiHost = baseUrl ? new URL(baseUrl).hostname : 'localhost';

Sentry.init({
	dsn: process.env.REACT_APP_SENTRY_DSN,
	integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
	// Performance Monitoring
	tracesSampleRate: 1.0, //  Capture 100% of the transactions
	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	tracePropagationTargets: [apiHost],
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

window.addEventListener('message', (event) => {
	event.preventDefault();
	if (!event.data || typeof event.data !== 'string' || event.origin === 'https://js.stripe.com') return;
	const config: IConfig = JSON.parse(event.data);
	const container = document.getElementById('widget-app');
	if (!root) {
		root = createRoot(container!); // createRoot(container!) if you use TypeScript
	}
	console.log(config, 'config');
	if (!config.publicKey) throw new Error('Cobuyr key is required');

	return root.render(
		<Context.Provider value={JSON.stringify(config)}>
			<App />
		</Context.Provider>
	);
});
